import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AsyncPipe } from '@angular/common';
import { DeviceStoreActions, LocationSubset } from '@era/stores';
import { Store } from '@ngrx/store';
import { PaneComponent } from '@rocksoft/cdk';
import { SyncType } from '@rocksoft/apple-sync-sdk';
import { AuthorizationService, Permissions } from '@rocksoft/shared/authorization';
import { Observable } from 'rxjs';
import { SyncTypeFilter } from './devices-sync-filter';
import { DevicesSyncModalComponent } from './devices-sync-modal.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-devices-sync-modal-container',
  templateUrl: './devices-sync-modal.container.html',
  imports: [PaneComponent, DevicesSyncModalComponent, AsyncPipe],
})
export class DevicesSyncModalContainerComponent {
  readonly activeModal = inject(NgbActiveModal);
  private readonly store = inject(Store);
  private readonly authorizationService = inject(AuthorizationService);

  public locationSubset = LocationSubset.All;
  private readonly syncTypes: SyncType[] = new Array<SyncType>();
  public isAdmin$: Observable<boolean>;

  constructor() {
    this.isAdmin$ = this.authorizationService.getIsAuthorized$(Permissions.Admin);
  }

  closeModal() {
    this.activeModal.close();
  }

  syncDevices(event: { filter: SyncTypeFilter; force: boolean }) {
    (Object.keys(event.filter) as (keyof typeof SyncType)[]).forEach((syncType) => {
      if (event.filter[syncType]) {
        this.syncTypes.push(syncType);
      }
    });

    this.store.dispatch(
      DeviceStoreActions.DevicesSyncModalActions.syncDevicesRequested({
        locationSubset: this.locationSubset,
        syncTypes: this.syncTypes,
        force: event.force,
      })
    );

    this.activeModal.close();
  }
}
